import axios from "@/plugins/axios";

export default {
    actions: {
        fetchSaleProductDailyRating(context, searchItem) {
            let url = "sale_product_daily_ratings?page="  + searchItem.page

            if (!context.state.saleProductDailyRating.isNeedFetch && !searchItem.isNeedFetch) {
                return
            }

            if (searchItem.byAmount) {
                url = url + '&order[amount]=desc'
            } else {
                url = url + '&order[incomeAmount]=desc'
            }

            if (searchItem.before) {
                url = url + '&date[before]=' + searchItem.before
            }

            if (searchItem.after) {
                url = url + '&date[after]=' + searchItem.after
            }

            return axios.get(url)
                .then((response) => {
                    console.log(response)

                    let data = {
                        models: response.data['hydra:member'],
                        totalItems: response.data['hydra:totalItems']
                    }

                    context.commit('updateSaleProductDailyRating', data)
                })
                .catch((err) => {
                    console.log(err)
                })
        },
    },
    mutations: {
        updateSaleProductDailyRating(state, data) {
            state.saleProductDailyRating = data
            state.saleProductDailyRating.isNeedFetch = false
        },
    },
    state: {
        saleProductDailyRating: {
            models: [],
            totalItems: 0,
            isNeedFetch: true
        },
    },
    getters: {
        getSaleProductDailyRating(state) {
            return state.saleProductDailyRating.models
        },
        getSaleProductDailyRatingTotalCount(state) {
            return state.saleProductDailyRating.totalItems
        },
    },
}
